<div class="pill-wrapper" [class.pill-wrapper--hidden]="detailsHidden">
  <ng-container *ngTemplateOutlet="dataSourceTemplate"></ng-container>
  <ng-container *ngTemplateOutlet="widgetGroupTemplate"></ng-container>
  <ng-container *ngTemplateOutlet="comparisonTemplate"></ng-container>
</div>

<ng-template #dataSourceTemplate>
  @for (
    ds of dataSourceData.source;
    track ds.id;
    let index = $index;
    let first = $first;
    let last = $last
  ) {
    <app-dashboard-pill
      [appPillHover]="ds"
      [isCondensed]="isDatasourceCondensed()"
      [dataSource]="ds"
      [activeWidgetCount]="dataSourceData.activeWidgetCount[ds.id]"
      [disabled]="disabled"
      [isReadOnly]="isReadOnly"
      [widget]="widget"
      [report]="report"
      [dashboard]="dashboard"
      [widgetComponent]="widgetComponent"
      [first]="first"
      [last]="last && widgetGroups()?.length < 1"
      (onActivitybarInteraction)="onInteraction($event)"
      (entityChooserVisible)="isEntityChooserVisible = $event"
    ></app-dashboard-pill>
  }
</ng-template>

<ng-template #widgetGroupTemplate>
  @for (wg of widgetGroups(); track wg; let first = $first; let last = $last) {
    <app-dashboard-pill
      [appPillHover]="wg"
      [widgetGroup]="wg"
      [isCondensed]="isWidgetGroupCondensed()"
      [entityList]="allWidgetGroupsForPage()"
      [disabled]="disabled"
      [isReadOnly]="isReadOnly"
      [widget]="widget"
      [report]="report"
      [dashboard]="dashboard"
      [widgetComponent]="widgetComponent"
      [first]="first && dataSourceData.source?.length < 1"
      [last]="last && comparisons?.length < 1"
      (onActivitybarInteraction)="onInteraction($event)"
      (entityChooserVisible)="isEntityChooserVisible = $event"
    ></app-dashboard-pill>
  }
</ng-template>

<ng-template #comparisonTemplate>
  @for (comparison of comparisons; track comparison; let first = $first; let last = $last) {
    <app-dashboard-pill
      [appPillHover]="comparison"
      [isCondensed]="isComparisonCondensed()"
      [disabled]="disabled"
      [comparison]="comparison"
      [entityList]="allComparisonsForPage"
      [widget]="widget"
      [report]="report"
      [dashboard]="dashboard"
      [widgetComponent]="widgetComponent"
      [first]="first && dataSourceData.source?.length < 1"
      [last]="last"
      [isReadOnly]="isReadOnly"
      (onActivitybarInteraction)="onInteraction($event)"
      (entityChooserVisible)="isEntityChooserVisible = $event"
    ></app-dashboard-pill>
  }
</ng-template>
